import { Component, OnInit } from '@angular/core';
import {TopicService } from '../topic.service'
import { GeneralComponent } from '../../General/g.component';
@Component({
  selector: 'app-exercises',
  templateUrl: './exercises.component.html',
  styleUrls: ['../../General/tiles.css','./exercises.component.css']
})
export class ExercisesComponent extends GeneralComponent{

  allExercises: any[] = null;
  allExams: any[] = null;
  page:number = 0;
  pageCount: number = 1;
  showTip = true;

  pageSize = 15;

  constructor(public topicService: TopicService) {
    super(topicService);
    this.allExercises = topicService.getAllExercisesInfo();
    this.allExams = topicService.getAllExamsInfo();
    this.pageCount = Math.max(Math.ceil((this.allExercises.length + this.allExams.length) / this.pageSize),1);
  }

  getItems(page: number){
    let start = (this.page)*this.pageSize;
    let end = (this.page+1)*this.pageSize;
    if(end <= this.allExercises.length){
      return this.allExercises.slice(start, end);
    } else if (start >= this.allExercises.length){
      return this.allExams.slice(start - this.allExercises.length, end-this.allExercises.length)
    } else {
      let exercisePart = this.allExercises.slice(start, this.allExercises.length);
      let examPart = this.allExams.slice(0, this.pageSize-exercisePart.length); 
      return exercisePart.concat(examPart);
    }
  }
}
